// assets/ss-cart-badge.js
(function () {
  if (window.SS_CART_BADGE && window.SS_CART_BADGE.update) return;

  function updateCartCountUI(cart) {
    const count = cart && typeof cart.item_count === "number" ? cart.item_count : null;
    if (count == null) return;

    // Emit theme-ish events (harmless if unused)
    try {
      const detail = { cart };
      ["cart:updated", "cart:change", "cart:refresh", "theme:cart:updated", "theme:cart:refresh"].forEach((name) => {
        document.dispatchEvent(new CustomEvent(name, { detail }));
      });
    } catch (e) {}

    function updateBadgeWithinCartTrigger(triggerEl) {
      if (!triggerEl) return false;

      // Empire: only aria-label here
      try {
        triggerEl.setAttribute("aria-label", `Cart (${count})`);
      } catch (e) {}

      const badge = triggerEl.querySelector("[data-header-cart-count]");
      if (!badge) return false;

      // Empire badge uses the data attribute (keep span empty)
      badge.setAttribute("data-header-cart-count", String(count));
      badge.textContent = "";

      badge.classList.toggle("visible", count > 0);
      badge.style.display = count > 0 ? "" : "none";

      return true;
    }

    const currentCartTrigger =
      document.querySelector("header a[href='/cart']") ||
      document.querySelector("header a[href^='/cart']") ||
      document.querySelector("header button[aria-label*='Cart']") ||
      document.querySelector("header a[aria-label*='Cart']");

    const updatedInPlace = updateBadgeWithinCartTrigger(currentCartTrigger);
    if (updatedInPlace && count !== 1) return;

    async function refreshCartTriggerFromHeaderSection() {
      function detectHandles() {
        const handles = new Set();

        const headerEl =
          document.querySelector("header") ||
          document.querySelector(".site-header") ||
          document.querySelector(".header");

        if (headerEl) {
          const headerSection = headerEl.closest("[id^='shopify-section-']");
          if (headerSection && headerSection.id) {
            handles.add(headerSection.id.replace("shopify-section-", ""));
          }
        }

        handles.add("header");
        handles.add("header-group");
        return Array.from(handles).filter(Boolean);
      }

      const handlesToTry = detectHandles();
      const url = "/?sections=" + handlesToTry.map(encodeURIComponent).join(",");

      try {
        const res = await fetch(url, {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        });
        if (!res.ok) return;

        const json = await res.json();

        for (const handle of handlesToTry) {
          const html = json && json[handle];
          if (!html) continue;

          const doc = new DOMParser().parseFromString(html, "text/html");
          const freshTrigger =
            doc.querySelector("a[href='/cart']") ||
            doc.querySelector("a[href^='/cart']") ||
            doc.querySelector("button[aria-label*='Cart']") ||
            doc.querySelector("a[aria-label*='Cart']");

          if (!freshTrigger) continue;
          if (!currentCartTrigger) continue;

          const imported = document.importNode(freshTrigger, true);
          currentCartTrigger.replaceWith(imported);

          updateBadgeWithinCartTrigger(
            document.querySelector("header a[href='/cart']") ||
              document.querySelector("header a[href^='/cart']") ||
              document.querySelector("header button[aria-label*='Cart']") ||
              document.querySelector("header a[aria-label*='Cart']")
          );

          break;
        }
      } catch (e) {}
    }

    refreshCartTriggerFromHeaderSection();
  }

  window.SS_CART_BADGE = { update: updateCartCountUI };
})();
